export default __webpack_public_path__ + "static/media/nodejs-icon.615ffbea.svg";